angular.module('bmsApp.employeeTeam')
	.controller('EmployeeViewModalCtrl', EmployeeViewModalCtrl);

EmployeeViewModalCtrl.$inject = [
	'$scope',
	'$modalInstance',
	'$ngBootbox',
	'group'
];

function EmployeeViewModalCtrl(
	$scope,
	$modalInstance,
	$ngBootbox,
	group
) {

	$scope.group = group;

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};
}
